/**
 * Files & Uploads API Service
 *
 * Handles all file-related API calls:
 * - Backup files
 * - Retrieve backup
 * - Delete files
 * - Download files
 * - Finish setup
 */

import { post, uploadFile } from './client';

export const filesApi = {
    /**
     * Upload backup files
     * @param {Object} backupData
     * @param {string} backupData.landlord_id - Landlord ID
     * @param {Array} backupData.files - Array of files with path and content
     * @param {string} backupData.folderName - Folder name
     * @returns {Promise<Object>} Backup response
     */
    backup: async (backupData) => {
        return post('pegasus/visionary/files/backup', backupData);
    },

    /**
     * Retrieve backup files
     * @param {Object} retrieveData
     * @param {string} retrieveData.landlord_id - Landlord ID
     * @param {string} retrieveData.path - Optional folder path
     * @returns {Promise<Object>} Backup files
     */
    retrieveBackup: async (retrieveData) => {
        return post('pegasus/visionary/files/retrieve/backup', retrieveData);
    },

    /**
     * Delete a file
     * @param {string} filePath - Path to file to delete
     * @returns {Promise<Object>} Delete response
     */
    deleteFile: async (filePath) => {
        return post('pegasus/visionary/files/delete/file', {
            path: filePath,
        });
    },

    /**
     * Download a file
     * @param {string} filePath - Path to file to download
     * @returns {Promise<Object>} File download response
     */
    downloadFile: async (filePath) => {
        return post('pegasus/visionary/files/download/file', {
            path: filePath,
        });
    },

    /**
     * Download files (tenant/property files)
     * @param {Object} downloadData - File download parameters
     * @returns {Promise<Object>} Download response
     */
    download: async (downloadData) => {
        return post('pegasus/visionary/files/download', downloadData);
    },

    /**
     * Mark setup as finished
     * @param {string} landlordId - Landlord ID
     * @returns {Promise<Object>} Finish setup response
     */
    finishSetup: async (landlordId) => {
        return post('pegasus/visionary/files/finishSetup', {
            landlord_id: landlordId,
        });
    },
};

export default filesApi;
